module.exports = __webpack_public_path__ + "static/media/question-circle-solid~PLywQpnu.4e4f6dcf.svg";